import { useMutation } from '@apollo/client';
import { defineMessages, useIntl } from 'react-intl';

import { getGqlErrors } from '../../helpers';
import GET_TASK_LIST_HEADER_INFO from 'components/projects/taskList/gql/getTaskListHeaderInfo.graphql';
import { SUBTASK_UPDATE_ANSWER_CHOICES } from '../graphql/mutations.graphql';
import toast from '../../../../../helpers/toast';

const useSubtaskUpdateAnswerChoice = ({ listId }) => {
  const { formatMessage } = useIntl();

  const messages = defineMessages({
    updateSubtaskAnswerChoiceError: {
      id: 'Project.taskList.subTasks.updateAnswerChoice',
      defaultMessage: 'There was an error selecting an answer',
      description: 'Error copy when updating a subtask answer',
    },
  });

  const handleOptimisticResponse = ({ input }) => {
    const { answerChoices, answerText, id } = input;

    return {
      subTaskUpdateAnswerChoices: {
        errors: [],
        __typename: 'SubTaskUpdateAnswerChoicesInput',
        subTask: {
          __typename: 'SubTask',
          id,
          answerChoices,
          answerText
        },
      },
      __typename: 'Mutation',
    };
  };
  const [updateSubtaskAnswerChoices] = useMutation(
    SUBTASK_UPDATE_ANSWER_CHOICES,
    {
      onCompleted: (data) => {
        const gqlErrors = getGqlErrors(data);
        if (gqlErrors.length) {
          toast.error(gqlErrors[0].message);
        }
      },
      onError: () =>
        toast.error(formatMessage(messages.updateSubtaskAnswerChoiceError)),
      optimisticResponse: handleOptimisticResponse,
      refetchQueries: [
        {
          query: GET_TASK_LIST_HEADER_INFO,
          variables: { id: listId },
        },
      ],
    },
  );

  return updateSubtaskAnswerChoices;
};

export default useSubtaskUpdateAnswerChoice;
